import { useTheme } from "../lib/theme"
import { Toaster as Sonner, type ToasterProps } from "sonner"
import { CheckCircleIcon, InfoIcon, WarningIcon, XCircleIcon, SpinnerIcon } from "@phosphor-icons/react"

const Toaster = ({ style, ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      icons={{
        success: (
          <CheckCircleIcon weight="fill" className="size-4" />
        ),
        info: (
          <InfoIcon weight="fill" className="size-4" />
        ),
        warning: (
          <WarningIcon weight="fill" className="size-4" />
        ),
        error: (
          <XCircleIcon weight="fill" className="size-4" />
        ),
        loading: (
          <SpinnerIcon weight="fill" className="size-4 animate-spin" />
        ),
      }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--border-radius": "var(--radius)",
          // A caller's style ADDS to these (e.g. the live map's `--width`)
          // rather than replacing the theme variables wholesale.
          ...style,
        } as React.CSSProperties
      }
      toastOptions={{
        classNames: {
          toast: "cn-toast",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
